import { useFeatureFlags } from '../../../infra/feature-flags';
import { isBrandSessionView, isShopSessionView, useSession } from '../../../infra/session';
import { canBrandUseEngage } from '../engage-access-utils';
export var useBarberEngagePermissionSettings = function () {
    var _a = useFeatureFlags(), isEngageForBarbersFlagOn = _a.engageForBarbers, isEngageForChairRentersFlagOn = _a.engageForChairRenters;
    var session = useSession().data;
    var isShopView = isShopSessionView(session.view);
    var canUseEngage = canBrandUseEngage(session);
    var isBrandView = isBrandSessionView(session.view);
    var shouldShowEngagePermissions = (isEngageForBarbersFlagOn || isEngageForChairRentersFlagOn) && canUseEngage;
    if (shouldShowEngagePermissions) {
        if (isShopView || isBrandView) {
            return {
                showEngagePermissionForBarbers: true,
                disableEngagePermission: false,
            };
        }
    }
    return {
        showEngagePermissionForBarbers: false,
        disableEngagePermission: false,
    };
};
